import React from 'react';
import Header from '../../Shared/Header';
import Footer from '../../Shared/Footer';
import TermsConditionModal from '../../Shared/TermsConditionModal';
import Footer2 from '../../Shared/Footer2';
import Input from '../../Shared/Input';
import Button from '../../Shared/Button';
import Upload from '../../Shared/UploadFile';
import '../../../css/ProfileManagement/BankInfo.css'
import save from '../../../Assets/ProfileManagement/Assets-Desktop/save.svg';
import savedark from '../../../Assets/ProfileManagement/Assets-Desktop/userprofile.svg';
import edit from '../../../Assets/ProfileManagement/Assets-Desktop/edit.svg';
import editlight from '../../../Assets/ProfileManagement/Assets-Desktop/editenable.svg';
import 'bootstrap/dist/css/bootstrap.min.css';
import SubmitModal from '../../Shared/SubmitModal';
import Message from '../../../Data/Shared/Message.json';
import ColorCode from '../../../Data/Shared/ColorCode.json';
import MetaDecorator from '../../../ReactHelmet/MetaDecorator';
import TitleDescription from '../../../Data/Shared/TitleDescription.json';
import POPIDisclaimerModal from '../../Shared/POPIDisclaimerModal';
import AddProfileModal from '../../Shared/GenericModalError';
import { AES, enc } from 'crypto-js';
import { connect } from 'react-redux';
//api url
import { baseURL, workFlowBaseURL } from '../../../Services/config/apiGateway';
import {
    COMPLETE_PROFILE_FORM_ENDPOINT,
    START_PROFILE_ENDPOINT,
    REWORK_PROFILE,
    GET_ALL_PROFILE_ENDPOINT,
    GET_ALL_PROFILE_DETAILS_ENDPOINT,
    PROFILE_ENDPOINT
} from '../../../Services/config/apiEndPoints';
import { ApiCall } from '../../../Services/utils/ApiCall';
let tempTaskId;
let companyInfoDetailsOfRespondent;
let companyInfoDetailsOfRequester;
class BankInfo extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            hasOpen: false,
            textInput: {},
            errors: {},
            bankDocument: '',
            bankDocumentName: '',
            uploadFileDisable: false,
            hasOpenterms: false,
            reworkCompanyData: {},
            //conditions edit AND save
            phone: false,
            profileApproved: ['Approved', 'approved', 'APPROVED'],
            profilePending: ['Pending', 'pending', 'PENDING'],
            profileIncomplete: ['Not Completed', 'not completed', 'NOT COMPLETED', 'Not completed'],
            profileRject: ['Rejected', 'rejected', 'REJECTED'],
            roletype: '',
            roleName: '',
            roleId: '',
            viewProfileRole: '',
            viewProfileStatus: '',
            saveAgain: false,
            clickEdit: false,
            clickSave: false,
            clickContinue: false,
            // for loader and page disable
            loadertime: false,
            pageDisable: false,
            hasOpenPending: false,
            taskId: '',
            profileRolesData: [],
            requesterProfileCreated: false,
            companyInfoDetailsOfRequester: [],
            companyInfoDetailsOfRespondent: [],
            hasOpenPOPIDisclaimer: false,
            hasAgreePOPIDisclaimer: false,
        }
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }
    // file upload remove require after upload
    uploadFileFunPassport = (uploadConfirm) => {
        let errors = {};
        errors["fileupload"] = "";
        this.setState({ errors: errors });
        document.getElementById('uploadCIPC').style.borderColor = ColorCode.colorCode.black;
    }
    removeBankUploadedLink = () => {
        let path = "";
        this.setState({
            bankDocument: path,
            bankDocumentName: path
        });
    }
    // file upload path
    setUploadLink = (filePathURL) => {
        this.setState({
            bankDocument: filePathURL,
            bankDocumentName: `Account_Confirmation_Letter.${filePathURL?.split('/')[11]?.split("'")[0]?.split('.')[1]}`
        });
        // for ulpoad loader end
        this.setState({ loadertime: false });
        this.setState({ pageDisable: false });
    }
    //for start loader when file uploading 
    setLoaderBank = (filePathURL) => {
        this.setState({ loadertime: filePathURL });
        this.setState({ pageDisable: filePathURL });
    }
    // view profile for not complete
    viewProfileDataAndTaskId = (roleTypeValue, profileTypeAndStatusValue) => {
        ApiCall(
            'GET',
            workFlowBaseURL + GET_ALL_PROFILE_ENDPOINT,
            {},
            {
                'Accept': 'application/json',
                'Content-Type': 'application/json',

            },
        ).then(data => {
            if (data.flag != -1) {
                if (data.flag == 500) {
                    console.log("I am 500")
                }
                else {
                    console.log('I am 200!');
                    data?.map((i, index) => (
                        data[index].taskData.profileUpdateRequest = JSON.parse(data[index].taskData.profileUpdateRequest)
                    ))
                    data?.every((md, index) => {
                        if (roleTypeValue?.includes(md.taskData.profileUpdateRequest.profileRole.roleType)) {
                            this.setState({ taskId: md.taskId });
                            let accountNo = '', branchC = '';
                            if (md.taskData.profileUpdateRequest.bankDetails.bankAccountNumber != 0) {
                                accountNo = md.taskData.profileUpdateRequest.bankDetails?.bankAccountNumber;
                            }
                            if (md.taskData.profileUpdateRequest.bankDetails.branchCode != 0) {
                                branchC = md.taskData.profileUpdateRequest.bankDetails?.branchCode;
                            }
                            var bankInfo = {
                                accountName: md.taskData.profileUpdateRequest.bankDetails?.accountName,
                                accountNumber: accountNo,
                                bankAdderss: md.taskData.profileUpdateRequest.bankDetails?.bankAddress,
                                branchCode: branchC,
                                branchName: md.taskData.profileUpdateRequest.bankDetails?.branchName
                            };
                            this.setState({
                                textInput: bankInfo,
                                bankDocument: md.taskData.profileUpdateRequest.bankDetails?.accountDocument?.documentPicture,
                                bankDocumentName: md.taskData.profileUpdateRequest.bankDetails?.accountDocument?.documentName,
                                uploadFileDisable: md.taskData.profileUpdateRequest.bankDetails?.accountDocument?.documentName?.length > 0 ? true : false
                            });
                            return false
                        }
                        return true
                    })
                }
            }
            else {
                console.log('something went wrong');
            }
        })
    }
    // view profile data for Approved
    viewPorfileDataOfApproved = () => {
        // for approved view profile
        ApiCall(
            'GET',
            baseURL + PROFILE_ENDPOINT + `?userName=${this.props.userProfileDataR?.userEmail}`,
            {},
            {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
        ).then(data => {
            if (data.flag != -1) {
                if (data.flag == 500) {
                    console.log('I am 500!');
                }
                else {
                    console.log('I am 200!');
                    let accountNo = '', branchC = '';
                    if (data.bankDetails?.accountNumber != 0) {
                        accountNo = data.bankDetails?.accountNumber;
                    }
                    if (data.bankDetails?.branchCode != 0) {
                        branchC = data.bankDetails?.branchCode;
                    }
                    //set view profile data in approved state
                    var bankInfo = {
                        accountName: data.bankDetails?.accountName,
                        accountNumber: accountNo,
                        bankAdderss: data.bankDetails?.bankAddress,
                        branchCode: branchC,
                        branchName: data.bankDetails?.branchName
                    };
                    this.setState({
                        textInput: bankInfo,
                        bankDocument: data.bankDetails?.accountDocument?.documentPicture,
                        bankDocumentName: data.bankDetails?.accountDocument?.documentName,
                        uploadFileDisable: data.bankDetails?.accountDocument?.documentName?.length > 0 ? true : false
                    });
                }
            }
            else {
                console.log('something went wrong');
            }
        })
    }
    // view profile data for Pending
    viewPorfileDataOfPending = (roleTypeValueData) => {
        ApiCall(
            'GET',
            workFlowBaseURL + GET_ALL_PROFILE_DETAILS_ENDPOINT,
            {},
            {
                'Accept': 'application/json',
                'Content-Type': 'application/json',

            },
        ).then(data => {
            if (data.flag != -1) {
                if (data.flag == 500) {
                    console.log("I am 500")
                }
                else {
                    console.log('I am 200!');
                    data?.map((i, index) => (
                        data[index].taskData.profileUpdateRequest = JSON.parse(data[index].taskData.profileUpdateRequest)
                    ))
                    data?.sort((a, b) =>
                        b.taskData.profileUpdateRequest?.submitDate - a.taskData.profileUpdateRequest?.submitDate
                    )
                    data?.every((md, index) => {
                        if (['ReviewProfile', 'reviewProfile'].includes(md.taskName) && roleTypeValueData === md.taskData.profileUpdateRequest.profileRole.roleType) {
                            let accountNo = '', branchC = '';
                            if (md.taskData?.profileUpdateRequest?.bankDetails?.bankAccountNumber != 0) {
                                accountNo = md.taskData?.profileUpdateRequest?.bankDetails?.bankAccountNumber;
                            }
                            if (md.taskData?.profileUpdateRequest?.bankDetails?.branchCode != 0) {
                                branchC = md.taskData?.profileUpdateRequest?.bankDetails?.branchCode;
                            }
                            //set data for view profile 
                            var bankInfo = {
                                accountName: md.taskData.profileUpdateRequest?.bankDetails?.accountName,
                                accountNumber: accountNo,
                                bankAdderss: md.taskData.profileUpdateRequest?.bankDetails?.bankAddress,
                                branchCode: branchC,
                                branchName: md.taskData.profileUpdateRequest?.bankDetails?.branchName
                            };
                            this.setState({
                                textInput: bankInfo,
                                bankDocument: md.taskData.profileUpdateRequest?.bankDetails?.accountDocument?.documentPicture,
                                bankDocumentName: md.taskData.profileUpdateRequest?.bankDetails?.accountDocument?.documentName,
                                uploadFileDisable: md.taskData.profileUpdateRequest?.bankDetails?.accountDocument?.documentName?.length > 0 ? true : false
                            });
                            return false
                        }
                        return true
                    })
                }
            }
            else {
                console.log('something went wrong');
            }
        })
    }
    componentDidMount(props) {
        // for find profile created roleType
        const { roleId, roleTypeValue, roleNameValue, profileTypeAndStatusValue } = this.props.match.params;
        this.setState({
            viewProfileRole: profileTypeAndStatusValue,
            roletype: roleTypeValue,
            roleId: roleId,
            viewProfileStatus: profileTypeAndStatusValue,
            roleName: roleNameValue,
        });
        if (['rejected', 'Rejected', 'REJECTED'].includes(profileTypeAndStatusValue)) {
            this.setState({ reworkCompanyData: this.props.history.location.state })
        }
        // check requester profile is created and approved state
        this.props.userProfileDataR?.profileRoles?.every((md, index) => {
            if (['Requester', 'requester'].includes(md.roleType) && ['Approved', 'approved', 'APPROVED'].includes(md.profileStatus)) {
                this.setState({ requesterProfileCreated: true });
                return false
            }
            return true
        })
        // view profile for respondent
        if (["Not Completed", 'Not completed', "not completed", "NOT COMPLETED", 'rejected', 'Rejected', 'REJECTED'].includes(profileTypeAndStatusValue) ||
            profileTypeAndStatusValue === "add-profile") {
            this.viewProfileDataAndTaskId(roleTypeValue, profileTypeAndStatusValue);
        }
        else if (["Approved", "approved", "APPROVED"].includes(profileTypeAndStatusValue)) {
            this.viewPorfileDataOfApproved();
        } else if (['Pending', 'pending', 'PENDING'].includes(profileTypeAndStatusValue)) {
            this.viewPorfileDataOfPending(roleTypeValue);
        }
        let phoneCheck = true;
        if (this.state.profileApproved.includes(profileTypeAndStatusValue) || this.state.profilePending.includes(profileTypeAndStatusValue) || this.state.profileIncomplete.includes(profileTypeAndStatusValue) || this.state.profileRject.includes(profileTypeAndStatusValue)) {
            //phoneCheck by default true;
            this.setState({ phone: true });
        }
        if (profileTypeAndStatusValue === 'add-profile') {
            phoneCheck = false;
            this.setState({ phone: false });
            this.state.roletype = "";
        }
        if (phoneCheck) {
            this.setState({ clickContinue: true });
            if (this.state.profilePending.includes(profileTypeAndStatusValue)) {
                this.setState({ hasOpenPending: true });
                document.getElementById('b2bttn').style.display = 'none';
            } else if (this.state.profileApproved.includes(profileTypeAndStatusValue)) {
                this.setState({ hasOpenPending: true });
            }
        }
    }
    workFlowApiReworkRespondent = (formAction) => {
        // api call for complete respondent profile
        ApiCall(
            'POST',
            workFlowBaseURL + REWORK_PROFILE + `?taskId=${this.state.taskId}`,
            {
                "email": this.props.userProfileDataR?.userEmail,
                "firstName": this.props.userProfileDataR?.firstName,
                "lastName": this.props.userProfileDataR?.lastName,
                "mobileNumber": this.props.userProfileDataR?.userMobile,
                // "approved": true,
                "bankDetails": {
                    "accountDocument": {
                        "documentName": this.state.bankDocumentName,
                        "documentPicture": this.state.bankDocument
                    },
                    "accountName": this.state.textInput["accountName"],
                    "accountNumber": this.state.textInput["accountNumber"],
                    "bankAddress": this.state.textInput["bankAdderss"],
                    "bankName": "",
                    "branchCode": this.state.textInput["branchCode"],
                    "branchName": this.state.textInput["branchName"]
                },
                // "comments": "string",
                "companyDetails": {
                    "companyDocument": {
                        "documentName": this.state.reworkCompanyData?.fileNameCIPC,
                        "documentPicture": this.state.reworkCompanyData?.filePathCIPC
                    },
                    "companyName": this.state.reworkCompanyData?.companyName,
                    "registrationNumber": this.state.reworkCompanyData?.companyRegNum,
                    "vatDocument": {
                        "documentName": this.state.reworkCompanyData?.fileNameVAT,
                        "documentPicture": this.state.reworkCompanyData?.filePathVAT
                    },
                    "vatNumber": this.state.reworkCompanyData?.vatRegNum,
                    "vatRegisteredFlag": this.state.reworkCompanyData?.isCheckVAT
                },
                "physicalAddress": {
                    "addressType": "physical",
                    "addressline1": this.state.reworkCompanyData?.addressL1,
                    "addressline2": this.state.reworkCompanyData?.addressline2,
                    "addressline3": "",
                    "addressline4": "",
                    "city": this.state.reworkCompanyData?.city,
                    "countryName": this.state.reworkCompanyData?.countryName,
                    "postalCode": this.state.reworkCompanyData?.postalCode,
                    "province": this.state.reworkCompanyData?.province
                },
                "postalAddress": {
                    "addressType": "postal",
                    "addressline1": this.state.reworkCompanyData?.postalAddressL1,
                    "addressline2": this.state.reworkCompanyData?.postalAddressL2,
                    "addressline3": "",
                    "addressline4": "",
                    "city": this.state.reworkCompanyData?.postalCity,
                    "countryName": this.state.reworkCompanyData?.postalCountry,
                    "postalCode": this.state.reworkCompanyData?.postalPostalCode,
                    "province": this.state.reworkCompanyData?.postalProvince
                },
                "profileRole": {
                    "roleId": this.state.roleId,
                    "roleName": this.state.roleName,
                    "roleType": this.state.roletype
                },
                "userId": this.props.userProfileDataR?.userId,
                "submitDate": new Date().getTime()
            },
            {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
        ).then(data => {
            if (data.flag != -1) {
                if (data.flag == '500') {
                    console.log('I am 500!');
                }
                else {
                    console.log('I am 200!');
                    if (formAction === 'submit') {
                        // for show when user submit profile
                        this.setState({ hasOpen: true });
                    }
                }
            }
            else {
                console.log('Something went wrong!');
            }
        });
    }
    workFlowApiCompleteForRespondent = (formAction) => {
        //find task id and company info details using respondent profile
        ApiCall(
            'GET',
            workFlowBaseURL + GET_ALL_PROFILE_ENDPOINT,
            {},
            {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
        ).then(data => {
            if (data.flag != -1) {
                if (data.flag == 500) {
                    console.log("I am 500")
                }
                else {
                    console.log('I am 200!');
                    data?.map((i, index) => (
                        data[index].taskData.profileUpdateRequest = JSON.parse(data[index].taskData.profileUpdateRequest)
                    ))
                    data?.every((md, index) => {
                        if (this.state.roletype.includes(md.taskData.profileUpdateRequest.profileRole.roleType)) {
                            tempTaskId = md.taskId;
                            companyInfoDetailsOfRespondent = md;
                            this.setState({
                                taskId: md.taskId,
                                companyInfoDetailsOfRespondent: md
                            })
                            return false
                        }
                        return true
                    });
                    // api call for complete respondent profile
                    ApiCall(
                        'POST',
                        workFlowBaseURL + COMPLETE_PROFILE_FORM_ENDPOINT + `?action=${formAction}&taskId=${tempTaskId}&userId=${this.props.userProfileDataR?.userId}`,
                        {
                            "email": this.props.userProfileDataR?.userEmail,
                            "firstName": this.props.userProfileDataR?.firstName,
                            "lastName": this.props.userProfileDataR?.lastName,
                            "mobileNumber": this.props.userProfileDataR?.userMobile,
                            // "approved": true,
                            "bankDetails": {
                                "accountDocument": {
                                    "documentName": this.state.bankDocumentName,
                                    "documentPicture": this.state.bankDocument
                                },
                                "accountName": this.state.textInput["accountName"],
                                "accountNumber": this.state.textInput["accountNumber"],
                                "bankAddress": this.state.textInput["bankAdderss"],
                                "bankName": "",
                                "branchCode": this.state.textInput["branchCode"],
                                "branchName": this.state.textInput["branchName"]
                            },
                            // "comments": "string",
                            "companyDetails": {
                                "companyDocument": {
                                    "documentName": companyInfoDetailsOfRespondent.taskData.profileUpdateRequest.companyDetails.companyDocument.documentName,
                                    "documentPicture": companyInfoDetailsOfRespondent.taskData.profileUpdateRequest.companyDetails.companyDocument.documentPicture
                                },
                                "companyName": companyInfoDetailsOfRespondent.taskData.profileUpdateRequest.companyDetails.companyName,
                                "registrationNumber": companyInfoDetailsOfRespondent.taskData.profileUpdateRequest.companyDetails.registrationNumber,
                                "vatDocument": {
                                    "documentName": companyInfoDetailsOfRespondent.taskData.profileUpdateRequest.companyDetails.vatDocument.documentName,
                                    "documentPicture": companyInfoDetailsOfRespondent.taskData.profileUpdateRequest.companyDetails.vatDocument.documentPicture
                                },
                                "vatNumber": companyInfoDetailsOfRespondent.taskData.profileUpdateRequest.companyDetails.vatNumber,
                                "vatRegisteredFlag": companyInfoDetailsOfRespondent.taskData.profileUpdateRequest.companyDetails.vatRegisteredFlag
                            },
                            "physicalAddress": {
                                "addressType": "physical",
                                "addressline1": companyInfoDetailsOfRespondent.taskData.profileUpdateRequest.physicalAddress.addressline1,
                                "addressline2": companyInfoDetailsOfRespondent.taskData.profileUpdateRequest.physicalAddress.addressline2,
                                "addressline3": "",
                                "addressline4": "",
                                "city": companyInfoDetailsOfRespondent.taskData.profileUpdateRequest.physicalAddress.city,
                                "countryName": companyInfoDetailsOfRespondent.taskData.profileUpdateRequest.physicalAddress.countryName,
                                "postalCode": companyInfoDetailsOfRespondent.taskData.profileUpdateRequest.physicalAddress.postalCode,
                                "province": companyInfoDetailsOfRespondent.taskData.profileUpdateRequest.physicalAddress.province
                            },
                            "postalAddress": {
                                "addressType": "postal",
                                "addressline1": companyInfoDetailsOfRespondent.taskData.profileUpdateRequest.postalAddress.addressline1,
                                "addressline2": companyInfoDetailsOfRespondent.taskData.profileUpdateRequest.postalAddress.addressline2,
                                "addressline3": "",
                                "addressline4": "",
                                "city": companyInfoDetailsOfRespondent.taskData.profileUpdateRequest.postalAddress.city,
                                "countryName": companyInfoDetailsOfRespondent.taskData.profileUpdateRequest.postalAddress.countryName,
                                "postalCode": companyInfoDetailsOfRespondent.taskData.profileUpdateRequest.postalAddress.postalCode,
                                "province": companyInfoDetailsOfRespondent.taskData.profileUpdateRequest.postalAddress.province
                            },
                            "profileRole": {
                                "roleId": companyInfoDetailsOfRespondent.taskData.profileUpdateRequest.profileRole.roleId,
                                "roleName": this.state.roleName,
                                "roleType": this.state.roletype
                            },
                            "userId": this.props.userProfileDataR?.userId,
                            "submitDate": new Date().getTime()
                        },
                        {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json',
                        }
                    ).then(apiData => {
                        if (apiData.flag != -1) {
                            if (apiData.flag == '500') {
                                console.log('I am 500!');
                            }
                            else {
                                console.log('I am 200!');
                                if (formAction === 'submit') {
                                    // for show when user submit profile
                                    this.setState({ hasOpen: true });
                                }
                            }
                        }
                        else {
                            console.log('Something went wrong!');
                        }
                    });
                }
            }
            else {
                console.log('something went wrong');
                //   return -1;
            }
        })
    }
    // if requester profile is already created for respondent only require to fill bank info data and company info will come from api response.
    workFlowApiNewWithRequester = (formAction) => {
        //find company info details with already approved  requester profile
        ApiCall(
            'GET',
            baseURL + PROFILE_ENDPOINT + `?userName=${this.props.userProfileDataR?.userEmail}`,
            {},
            {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
        ).then(data => {
            if (data.flag != -1) {
                if (data.flag == 500) {
                    console.log("I am 500")
                }
                else {
                    console.log('I am 200!');
                    companyInfoDetailsOfRequester = data;
                    this.setState({ companyInfoDetailsOfRequester: data });
                    ApiCall(
                        'POST',
                        workFlowBaseURL + START_PROFILE_ENDPOINT + `?action=${formAction}`,
                        {
                            "email": this.props.userProfileDataR?.userEmail,
                            "firstName": this.props.userProfileDataR?.firstName,
                            "lastName": this.props.userProfileDataR?.lastName,
                            "mobileNumber": this.props.userProfileDataR?.userMobile,
                            // "approved": true,
                            "bankDetails": {
                                "accountDocument": {
                                    "documentName": this.state.bankDocumentName,
                                    "documentPicture": this.state.bankDocument
                                },
                                "accountName": this.state.textInput["accountName"],
                                "accountNumber": this.state.textInput["accountNumber"],
                                "bankAddress": this.state.textInput["bankAdderss"],
                                "bankName": "",
                                "branchCode": this.state.textInput["branchCode"],
                                "branchName": this.state.textInput["branchName"]
                            },
                            // "comments": "string",
                            "companyDetails": {
                                "companyDocument": {
                                    "documentName": companyInfoDetailsOfRequester.companyDetails?.companyDocument?.documentName,
                                    "documentPicture": companyInfoDetailsOfRequester.companyDetails?.companyDocument?.documentPicture
                                },
                                "companyName": companyInfoDetailsOfRequester.companyDetails?.companyName,
                                "registrationNumber": companyInfoDetailsOfRequester.companyDetails?.registrationNumber,
                                "vatDocument": {
                                    "documentName": companyInfoDetailsOfRequester.companyDetails?.vatDocument?.documentName,
                                    "documentPicture": companyInfoDetailsOfRequester.companyDetails?.vatDocument?.documentPicture
                                },
                                "vatNumber": companyInfoDetailsOfRequester.companyDetails?.vatNumber,
                                "vatRegisteredFlag": companyInfoDetailsOfRequester?.companyDetails?.vatRegisteredFlag
                            },
                            "physicalAddress": {
                                "addressType": "physical",
                                "addressline1": companyInfoDetailsOfRequester?.address[1]?.addressline1,
                                "addressline2": companyInfoDetailsOfRequester?.address[1]?.addressline2,
                                "addressline3": "",
                                "addressline4": "",
                                "city": companyInfoDetailsOfRequester?.address[1]?.city,
                                "countryName": companyInfoDetailsOfRequester?.address[1]?.countryName,
                                "postalCode": companyInfoDetailsOfRequester?.address[1]?.postalCode,
                                "province": companyInfoDetailsOfRequester?.address[1]?.province
                            },
                            "postalAddress": {
                                "addressType": "postal",
                                "addressline1": companyInfoDetailsOfRequester?.address[0]?.addressline1,
                                "addressline2": companyInfoDetailsOfRequester?.address[0]?.addressline2,
                                "addressline3": "",
                                "addressline4": "",
                                "city": companyInfoDetailsOfRequester?.address[0]?.city,
                                "countryName": companyInfoDetailsOfRequester?.address[0]?.countryName,
                                "postalCode": companyInfoDetailsOfRequester?.address[0]?.postalCode,
                                "province": companyInfoDetailsOfRequester?.address[0]?.province
                            },
                            "profileRole": {
                                "roleId": this.state.roleId,
                                "roleName": this.state.roleName,
                                "roleType": this.state.roletype
                            },
                            "userId": this.props.userProfileDataR?.userId,
                            "submitDate": new Date().getTime()
                        },
                        {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json',
                        }
                    ).then(apiData => {
                        if (apiData.flag != -1) {
                            if (apiData.flag == '500') {
                                console.log('I am 500!');
                            }
                            else {
                                console.log('I am 200!');
                                if (formAction === 'submit') {
                                    this.setState({ hasOpen: true });
                                }
                                else {
                                    //set save value for second time save calling
                                    this.viewProfileDataAndTaskId(this.state.roletype, this.state.viewProfileStatus);
                                }
                            }
                        }
                        else {
                            console.log('Something went wrong!');
                        }
                    });
                }
            }
            else {
                console.log('something went wrong');
            }
        })
    }
    workFlowApiCompleteWithRequester = (formAction) => {
        ApiCall(
            'GET',
            workFlowBaseURL + GET_ALL_PROFILE_ENDPOINT,
            {},
            {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
        ).then(data => {
            if (data.flag != -1) {
                if (data.flag == 500) {
                    console.log("I am 500")
                }
                else {
                    console.log('I am 200!');
                    data.map((i, index) => (
                        data[index].taskData.profileUpdateRequest = JSON.parse(data[index].taskData.profileUpdateRequest)
                    ))
                    data?.every((md, index) => {
                        if (this.state.roletype.includes(md.taskData.profileUpdateRequest.profileRole.roleType)) {
                            this.setState({
                                taskId: md.taskId,
                                companyInfoDetailsOfRequester: md
                            });
                            tempTaskId = md.taskId;
                            return false
                        }
                        return true
                    })
                    ApiCall(
                        'POST',
                        workFlowBaseURL + COMPLETE_PROFILE_FORM_ENDPOINT + `?action=${formAction}&taskId=${tempTaskId}&userId=${this.props.userProfileDataR?.userId}`,
                        {
                            "email": this.props.userProfileDataR?.userEmail,
                            "firstName": this.props.userProfileDataR?.firstName,
                            "lastName": this.props.userProfileDataR?.lastName,
                            "mobileNumber": this.props.userProfileDataR?.userMobile,
                            // "approved": true,
                            "bankDetails": {
                                "accountDocument": {
                                    "documentName": this.state.bankDocumentName,
                                    "documentPicture": this.state.bankDocument
                                },
                                "accountName": this.state.textInput["accountName"],
                                "accountNumber": this.state.textInput["accountNumber"],
                                "bankAddress": this.state.textInput["bankAdderss"],
                                "bankName": "",
                                "branchCode": this.state.textInput["branchCode"],
                                "branchName": this.state.textInput["branchName"]
                            },
                            // "comments": "string",
                            "companyDetails": {
                                "companyDocument": {
                                    "documentName": companyInfoDetailsOfRequester.companyDetails.companyDocument.documentName,
                                    "documentPicture": companyInfoDetailsOfRequester.companyDetails.companyDocument.documentPicture
                                },
                                "companyName": companyInfoDetailsOfRequester.companyDetails.companyName,
                                "registrationNumber": companyInfoDetailsOfRequester.companyDetails.registrationNumber,
                                "vatDocument": {
                                    "documentName": companyInfoDetailsOfRequester.companyDetails.vatDocument.documentName,
                                    "documentPicture": companyInfoDetailsOfRequester.companyDetails.vatDocument.documentPicture
                                },
                                "vatNumber": companyInfoDetailsOfRequester.companyDetails.vatNumber,
                                "vatRegisteredFlag": companyInfoDetailsOfRequester.companyDetails.vatRegisteredFlag
                            },
                            "physicalAddress": {
                                "addressType": "physical",
                                "addressline1": companyInfoDetailsOfRequester.physicalAddress.addressline1,
                                "addressline2": companyInfoDetailsOfRequester.physicalAddress.addressline2,
                                "addressline3": "",
                                "addressline4": "",
                                "city": companyInfoDetailsOfRequester.physicalAddress.city,
                                "countryName": companyInfoDetailsOfRequester.physicalAddress.countryName,
                                "postalCode": companyInfoDetailsOfRequester.physicalAddress.postalCode,
                                "province": companyInfoDetailsOfRequester.physicalAddress.province
                            },
                            "postalAddress": {
                                "addressType": "postal",
                                "addressline1": companyInfoDetailsOfRequester.postalAddress.addressline1,
                                "addressline2": companyInfoDetailsOfRequester.postalAddress.addressline2,
                                "addressline3": "",
                                "addressline4": "",
                                "city": companyInfoDetailsOfRequester.postalAddress.city,
                                "countryName": companyInfoDetailsOfRequester.postalAddress.countryName,
                                "postalCode": companyInfoDetailsOfRequester.postalAddress.postalCode,
                                "province": companyInfoDetailsOfRequester.postalAddress.province
                            },
                            "profileRole": {
                                "roleId": this.state.roleId,
                                "roleName": this.state.roleName,
                                "roleType": this.state.roletype
                            },
                            "userId": this.props.userProfileDataR?.userId,
                            "submitDate": new Date().getTime()
                        },
                        {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json',
                        }
                    ).then(apiData => {
                        if (apiData.flag != -1) {
                            if (apiData.flag == '500') {
                                console.log('I am 500!');
                            }
                            else {
                                console.log('I am 200!');
                                if (formAction === 'submit') {
                                    // for show when user submit profile
                                    this.setState({ hasOpen: true });
                                }
                            }
                        }
                        else {
                            console.log('Something went wrong!');
                        }
                    });
                }
            }
            else {
                console.log('something went wrong');
            }
        })
    }
    editClicked = () => {
        this.setState({ clickEdit: true, clickSave: false, clickContinue: false });
        if (this.state.profileApproved.includes(this.state.viewProfileStatus) || this.state.profileRject.includes(this.state.viewProfileStatus)) {
            this.setState({ clickContinue: true });
        }
    }
    saveClicked = event => {
        event.preventDefault();
        this.setState({ clickEdit: false, clickSave: true, clickContinue: true });
        //if requester profile is already created for new respondent
        if (this.state.requesterProfileCreated && this.state.viewProfileStatus === 'add-profile' && !this.state.taskId) {
            this.workFlowApiNewWithRequester('save');
        }
        //if requester profile is already created for complete respondent profile
        else if (this.state.requesterProfileCreated && this.state.viewProfileStatus === 'add-profile' && this.state.taskId) {
            this.workFlowApiCompleteWithRequester('save');
        }
        else if (this.state.viewProfileStatus === 'add-profile' && !this.state.requesterProfileCreated) {
            this.workFlowApiCompleteForRespondent('save');
        }
        //api call for complete task SAVE API CALL FOR EXISTING USER COMPLETE FORM
        // view profile flow
        else if (["Not Completed", 'Not completed', "not completed", "NOT COMPLETED"].includes(this.state.viewProfileStatus)) {
            this.workFlowApiCompleteForRespondent('save');
        }
        else if (["Rejected", "rejected", "REJECTED"].includes(this.state.viewProfileStatus)) {
            this.workFlowApiReworkRespondent('save');
        }
    }
    alertSubmit = () => {
        alert("Please click save to continue");
    }
    onCloseModal = () => {
        this.setState({ hasOpen: false });
        this.props.history.push({
            pathname: '/home'
        });
    };
    onClosePending = () => {
        this.setState({ hasOpenPending: false });
    };
    onAddHandleUser = () => {
        this.setState({ hasOpenterms: true });
    }
    onClosetermsModal = () => {
        this.setState({ hasOpenterms: false });
    };
    openPOPIDisclaimer = () => {
        this.setState({ hasOpenPOPIDisclaimer: true })
    }
    onCrossPOPIDisclaimerModal = () => {
        this.setState({ hasOpenPOPIDisclaimer: false })
    }
    handleAgree = () => {
        if (this.state.hasAgreePOPIDisclaimer) {
            this.setState({ hasAgreePOPIDisclaimer: false })
            // if requester profile is already created 
            if (this.state.requesterProfileCreated && this.state.viewProfileStatus === 'add-profile' && !this.state.taskId) {
                this.workFlowApiNewWithRequester('submit');
            }
            if (this.state.requesterProfileCreated && this.state.viewProfileStatus === 'add-profile' && this.state.taskId) {
                this.workFlowApiCompleteWithRequester('submit');
            }
            // if requester profile is not present  and click second time on submit
            else if (this.state.viewProfileStatus === 'add-profile' && !this.state.requesterProfileCreated) {
                this.workFlowApiCompleteForRespondent('submit');
            }
            if (['Not Completed', 'Not completed', 'not completed', 'NOT COMPLETED', 'Approved', 'approved', 'APPROVED'].includes(this.state.viewProfileStatus)) {
                this.workFlowApiCompleteForRespondent('submit');
            } else if (["Rejected", "rejected", "REJECTED"].includes(this.state.viewProfileStatus)) {
                this.workFlowApiReworkRespondent('submit');
            }
        }
    }
    handleSubmit = () => {
        if (this.handleValidation()) {
            this.setState({ hasAgreePOPIDisclaimer: true })
        }
    }
    handleValidation() {
        let fields = this.state.textInput;
        let errors = {};
        let formIsValid = true;
        var patternCharacter = new RegExp(/^[a-zA-Z ]*$/);
        var patternDigit = new RegExp(/^[0-9\b]+$/);
        var alphanumeric = new RegExp(/[^a-zA-Z0-9]/);
        if (!fields["accountName"]) {
            formIsValid = false;
            errors["accountName"] = "Required";
            document.getElementById('accountName').style.borderColor = ColorCode.colorCode.red;
        }
        else if (!patternCharacter.test(fields["accountName"])) {
            formIsValid = false;
            errors["accountName"] = Message.validation.alpha;
            document.getElementById('accountName').style.borderColor = ColorCode.colorCode.red;
        } else {
            document.getElementById('accountName').style.borderColor = ColorCode.colorCode.black;
        }
        if (!fields["accountNumber"]) {
            formIsValid = false;
            errors["accountNumber"] = "Required";
            document.getElementById('accountNumber').style.borderColor = ColorCode.colorCode.red;
        }
        else if (!patternDigit.test(fields["accountNumber"])) {
            formIsValid = false;
            errors["accountNumber"] = "Please enter numbers";
            document.getElementById('accountNumber').style.borderColor = ColorCode.colorCode.red;
        } else {
            document.getElementById('accountNumber').style.borderColor = ColorCode.colorCode.black;
        }
        if (!patternCharacter.test(fields["branchName"])) {
            formIsValid = false;
            errors["branchName"] = Message.validation.alpha;
            document.getElementById('branchName').style.borderColor = ColorCode.colorCode.red;
        } else if (patternCharacter.test(fields["branchName"])) {
            document.getElementById('branchName').style.borderColor = ColorCode.colorCode.black;
        }
        if (!fields["branchCode"]) {
            formIsValid = false;
            errors["branchCode"] = "Required";
            document.getElementById('branchCode').style.borderColor = ColorCode.colorCode.red;
        }
        else if (!patternDigit.test(fields["branchCode"])) {
            formIsValid = false;
            errors["branchCode"] = Message.validation.num;
            document.getElementById('branchCode').style.borderColor = ColorCode.colorCode.red;
        } else {
            document.getElementById('branchCode').style.borderColor = ColorCode.colorCode.black;
        }
        if (!fields["bankAdderss"]) {
            formIsValid = false;
            errors["bankAdderss"] = "Required";
            document.getElementById('bankAdderss').style.borderColor = ColorCode.colorCode.red;
        } else {
            document.getElementById('bankAdderss').style.borderColor = ColorCode.colorCode.black;
        }
        if (this.state.bankDocumentName?.length == 0 && this.state.bankDocument?.length == 0) {
            formIsValid = false;
            errors["fileupload"] = "Required";
            document.getElementById('uploadCIPC').style.borderColor = ColorCode.colorCode.red;
        } else {
            document.getElementById('uploadCIPC').style.borderColor = ColorCode.colorCode.black;
        }
        this.setState({ errors: errors });
        return formIsValid;
    }
    handleChange(field, e) {
        let fields = this.state.textInput;
        let errors = this.state.errors;
        fields[field] = e.target.value;
        this.setState({ fields });
        errors[field] = "";
        document.getElementById(field).style.borderColor = ColorCode.colorCode.black;
    }
    render() {
        return (
            <div class="BankBackColor">
                <div class="full">
                    <MetaDecorator title={TitleDescription.bankInfoPageTitle} description={TitleDescription.bankInfoPageDescription} />
                    <Header tilesFetched={() => { }} />
                    <div id="BankInformationBox">
                        <div className="BankInformationNavbar " class="BankInformationNavbar">
                            <div className="BankInformationNavbarname">
                                <small id="navc">My Profile</small>
                            </div>
                            <div class="BankInformationNavSave ">
                                {
                                    this.state.phone ?
                                        <div>
                                            {
                                                this.state.profileApproved.includes(this.state.viewProfileStatus) || this.state.profileRject.includes(this.state.viewProfileStatus) ?
                                                    <div>
                                                        {
                                                            this.state.clickEdit ?
                                                                <div>
                                                                    <img src={editlight} class=" mr-1 pb-1" id="editicon" alt="" loading="lazy" />
                                                                    <small id="editlight" class=" pr-4" >Edit</small>
                                                                </div>
                                                                :
                                                                <div>
                                                                    <img src={edit} class=" mr-1 pb-1" id="editicon" alt="" loading="lazy" />
                                                                    <small id="edit" class=" pr-4" onClick={this.editClicked} >Edit</small>
                                                                </div>
                                                        }
                                                    </div>
                                                    :
                                                    <div>
                                                        {
                                                            this.state.profilePending.includes(this.state.viewProfileStatus) ?
                                                                <div>
                                                                    <img src={editlight} class=" mr-1 pb-1" id="editicon" alt="" loading="lazy" />
                                                                    <small id="editlight" class=" pr-4" >Edit</small>
                                                                    <img src={save} class=" mr-1 pb-1" id="saveicon" alt="" loading="lazy" />
                                                                    <small id="save" >Save</small>
                                                                </div>
                                                                :
                                                                <div>
                                                                    {
                                                                        this.state.profileIncomplete.includes(this.state.viewProfileStatus) ?
                                                                            <div>
                                                                                {
                                                                                    this.state.clickEdit ?
                                                                                        <div>
                                                                                            <img src={editlight} class=" mr-1 pb-1" id="editicon" alt="" loading="lazy" />
                                                                                            <small id="editlight" class=" pr-4" >Edit</small>
                                                                                            <img src={savedark} class=" mr-1 pb-1" id="saveicon" alt="" loading="lazy" />
                                                                                            <small id="savedark" onClick={this.saveClicked} >Save</small>
                                                                                        </div>
                                                                                        :
                                                                                        <div>
                                                                                            <img src={edit} class=" mr-1 pb-1" id="editicon" alt="" loading="lazy" />
                                                                                            <small id="edit" class=" pr-4" onClick={this.editClicked} >Edit</small>
                                                                                            <img src={save} class=" mr-1 pb-1" id="saveicon" alt="" loading="lazy" />
                                                                                            <small id="save" >Save</small>
                                                                                        </div>
                                                                                }
                                                                            </div>
                                                                            :
                                                                            <div>
                                                                                {this.state.clickEdit ?
                                                                                    <div>
                                                                                        <img src={editlight} class=" mr-1 pb-1" id="editicon" alt="" loading="lazy" />
                                                                                        <small id="editlight" class=" pr-4" >Edit</small>
                                                                                        <img src={savedark} class=" mr-1 pb-1" id="saveicon" alt="" loading="lazy" />
                                                                                        <small id="savedark" onClick={this.saveClicked} >Save</small>
                                                                                    </div>
                                                                                    :
                                                                                    <div>
                                                                                        <img src={edit} class=" mr-1 pb-1" id="editicon" alt="" loading="lazy" />
                                                                                        <small id="edit" class=" pr-4" onClick={this.editClicked} >Edit</small>
                                                                                        <img src={save} class=" mr-1 pb-1" id="saveicon" alt="" loading="lazy" />
                                                                                        <small id="save" >Save</small>
                                                                                    </div>
                                                                                }
                                                                            </div>
                                                                    }
                                                                </div>
                                                        }
                                                    </div>
                                            }
                                        </div>
                                        :
                                        <div>
                                            {this.state.clickSave ?
                                                <div>
                                                    <img src={edit} class=" mr-1 pb-1" id="editicon" alt="" loading="lazy" />
                                                    <small id="edit" class=" pr-4" onClick={this.editClicked} >Edit</small>
                                                    <img src={save} class=" mr-1 pb-1" id="saveicon" alt="" loading="lazy" />
                                                    <small id="save" >Save</small>
                                                </div>
                                                :
                                                <div>
                                                    <img src={editlight} class=" mr-1 pb-1" id="editicon" alt="" loading="lazy" />
                                                    <small id="editlight" class=" pr-4" >Edit</small>
                                                    <img src={savedark} class=" mr-1 pb-1" id="saveicon" alt="" loading="lazy" />
                                                    <small id="savedark" onClick={this.saveClicked} >Save</small>
                                                </div>
                                            }
                                        </div>
                                }
                            </div>
                        </div>
                        <hr class="hr1" />
                        <div class="maincardBankInfo">
                            <div class="bank1">
                                <small id="BankaCardTitle">Bank Information</small>
                            </div>
                            <div class='BankOuterCardCss' id={(this.state.clickSave || (this.state.phone && !this.state.clickEdit)) && "MakeBankFormDivPointerNone"} >
                                <div class='BankDivCardCss'>
                                    <div class='BankInputDivCss'>
                                        <small id="name">Account Name</small>
                                        <br />
                                        <Input class="input" id="accountName" type="text" name="accountName"
                                            value={this.state.textInput["accountName"]}
                                            readOnly={this.state.clickSave || (this.state.phone && !this.state.clickEdit)}
                                            onChange={this.handleChange.bind(this, "accountName")}
                                        />
                                        <br />
                                        <div className="error1">{this.state.errors["accountName"]}</div>
                                    </div>
                                    <div class='BankInputDivCss'>
                                        <small id="name">Account Number</small>
                                        <br />
                                        <Input class="input" id="accountNumber" type="text" name="accountNumber"
                                            value={this.state.textInput["accountNumber"]}
                                            readOnly={this.state.clickSave || (this.state.phone && !this.state.clickEdit)}
                                            onChange={this.handleChange.bind(this, "accountNumber")} />
                                        <br />
                                        <div className="error1">{this.state.errors["accountNumber"]}</div>
                                    </div>
                                </div>
                                <div class='BankDivCardBottomCss'>
                                    <div class='BankInputDivCss'>
                                        <small id="name">Branch Name(optional)</small>
                                        <br />
                                        <Input class="input" id="branchName" type="text" name="branchName"
                                            value={this.state.textInput["branchName"]}
                                            readOnly={this.state.clickSave || (this.state.phone && !this.state.clickEdit)}
                                            onChange={this.handleChange.bind(this, "branchName")}
                                        />
                                        <br />
                                        <div className="error1">{this.state.errors["branchName"]}</div>
                                    </div>
                                    <div class='BankInputDivCss'>
                                        <small id="name">Branch Code</small>
                                        <br />
                                        <Input type="text" id="branchCode" class="input" name="branchCode"
                                            value={this.state.textInput["branchCode"]}
                                            readOnly={this.state.clickSave || (this.state.phone && !this.state.clickEdit)}
                                            onChange={this.handleChange.bind(this, "branchCode")} />
                                        <br />
                                        <div className="error1">{this.state.errors["branchCode"]}</div>
                                    </div>
                                </div>
                                <div class='BankDivCardBottomCss'>
                                    <div class='BankInputDivCss'>
                                        <small id="name">Bank Address</small>
                                        <br />
                                        <Input type="text" id="bankAdderss" class="input" name="bankAdderss"
                                            value={this.state.textInput["bankAdderss"]}
                                            readOnly={this.state.clickSave || (this.state.phone && !this.state.clickEdit)}
                                            onChange={this.handleChange.bind(this, "bankAdderss")} />
                                        <br />
                                        <div className="error1">{this.state.errors["bankAdderss"]}</div>
                                    </div>
                                    <div class='BankInputDivCss'>
                                        <small id="nameu2">Upload Bank Account Confirmation Letter</small>
                                        <br />
                                        {this.state.uploadFileDisable &&
                                            <Upload uploaddivid="uploadCIPC" idupload="upload" name="fileupload"
                                                setUploadConfirm={this.uploadFileFunPassport}
                                                removeLink={this.removeBankUploadedLink}
                                                setFileLink={this.setUploadLink}
                                                setLoader={this.setLoaderBank}
                                                pdfFileName={this.state.bankDocumentName}
                                                isUploadDisabled={this.state.uploadFileDisable}
                                                staticFileName={'Account_Confirmation_Letter.'}
                                                fileType="jpeg, jpg, png, pdf"
                                            />
                                        }
                                        {!this.state.uploadFileDisable &&
                                            <Upload uploaddivid="uploadCIPC" idupload="upload" name="fileupload"
                                                setUploadConfirm={this.uploadFileFunPassport}
                                                removeLink={this.removeBankUploadedLink}
                                                setFileLink={this.setUploadLink}
                                                setLoader={this.setLoaderBank}
                                                pdfFileName={this.state.bankDocumentName}
                                                isUploadDisabled={this.state.uploadFileDisable}
                                                staticFileName={'Account_Confirmation_Letter.'}
                                                fileType="jpeg, jpg, png, pdf"
                                            />
                                        }
                                        <div className="error1">{this.state.errors["fileupload"]}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="BankInformationPopiDiv" onClick={this.openPOPIDisclaimer}>POPI Disclaimer</div>
                            <div class="BankInformationBtn">
                                <Button id="b2bttn" class="BankInformationButton" onClick={this.handleSubmit}>Submit</Button>
                            </div>
                        </div>
                    </div>
                    <div class="b2footer22">
                        <Footer2 />
                        {this.state.hasOpenterms ? <TermsConditionModal onClick={this.onClosetermsModal} /> : null}
                    </div>
                </div>
                <div class="b2footer11">
                    <Footer />
                </div>
                <SubmitModal hasOpen={this.state.hasOpen} onCloseModal={this.onCloseModal} />
                {/* pending state pop up modal */}
                {this.state.hasOpenPending ? <AddProfileModal hasOpen={this.state.hasOpenPending} onCloseModal={this.onClosePending} >
                    <div>
                        <div class="successtext1outercreatepreadvise">
                            <small class="addprofilemodalsmall">{
                                this.state.profileApproved.includes(this.state.viewProfileStatus) ?
                                    Message.profileManagement.approvedProfile
                                    :
                                    Message.profileManagement.pendingProfile}</small>
                        </div>
                    </div>
                </AddProfileModal> : null}
                {this.state.hasOpenPOPIDisclaimer ?
                    <POPIDisclaimerModal
                        showButton={false}
                        hasOpen={this.state.hasOpenPOPIDisclaimer}
                        onCrossModal={this.onCrossPOPIDisclaimerModal}
                    >
                    </POPIDisclaimerModal>
                    : null
                }
                {this.state.hasAgreePOPIDisclaimer ?
                    <POPIDisclaimerModal
                        showButton={true}
                        hasOpen={this.state.hasAgreePOPIDisclaimer}
                        onCloseModal={this.handleAgree}
                        buttonLabel={"Agree"}
                    >
                    </POPIDisclaimerModal>
                    : null
                }
            </div>
        );
    }
}
function mapStateToProps(state) {
    if (state.userProfileInfoReducer.data) {
        return {
            userProfileDataR: JSON.parse(AES.decrypt(state.userProfileInfoReducer.data, 'TPT_CARGO_CONNECT').toString(enc.Utf8))
        }
    }
}
export default connect(mapStateToProps)(BankInfo);
